class MainNavigation extends HTMLElement {

    constructor() {
        super();
        this.featuredElementFirst = this.querySelector('[data-featured-element-first]');
        this.featuredElementFirstTitle = this.featuredElementFirst.querySelector('[data-title]');
        this.featuredElementFirstImage = this.featuredElementFirst.querySelector('[data-image]').querySelector('img');

        this.featuredElementSecond = this.querySelector('[data-featured-element-second]');
        this.featuredElementSecondTitle = this.featuredElementSecond.querySelector('[data-title]');
        this.featuredElementSecondImage = this.featuredElementSecond.querySelector('[data-image]').querySelector('img');

        this.teaserLinksFirst = document.querySelectorAll('[data-teaser-element-first]');
        this.teaserLinksSecond = document.querySelectorAll('[data-teaser-element-second]');

        this.addEventListener('click', this.handleClick);
        this.genderSettings = this.getGenderCookieSettings();
        // this.checkGenderCookie();

        this.close_field = document.getElementById('main-navigation--close-field');
        if(this.close_field){
          this.close_field.addEventListener('click', this.close.bind(this));
        }

        swipedetect(this, function(swipedir){
          if(document.body.classList.contains('main-navigation--show')){
            if(swipedir=='left'){
              this.close();
            }
          }
        }.bind(this))

        this.teaserLinksFirst.forEach(teaserLink => {
            teaserLink.addEventListener("mouseover", () => {
                const title = teaserLink.getAttribute('data-teaser-title');
                const image = teaserLink.getAttribute('data-teaser-image');
                const url = teaserLink.getAttribute('data-teaser-url');
                if (title != '') {
                    this.featuredElementFirstTitle.innerHTML = title;
                } else {
                    this.featuredElementFirstTitle.innerHTML = '';
                }
                if (image != '') {
                    this.featuredElementFirstImage.setAttribute('src', image);
                    this.featuredElementFirstImage.classList.remove('hidden');
                } else {
                    this.featuredElementFirstImage.classList.add('hidden');
                    this.featuredElementFirstImage.setAttribute('src', '');
                }
                if (url != '') {
                    this.featuredElementFirst.setAttribute('href', url);
                } else {
                    this.featuredElementFirst.setAttribute('href', '#');
                }
            }, false);
        });
        this.teaserLinksSecond.forEach(teaserLink => {
            teaserLink.addEventListener("mouseover", () => {
                const title = teaserLink.getAttribute('data-teaser-title');
                const image = teaserLink.getAttribute('data-teaser-image');
                const url = teaserLink.getAttribute('data-teaser-url');
                if (title != '') {
                    this.featuredElementSecondTitle.innerHTML = title;
                } else {
                    this.featuredElementSecondTitle.innerHTML = '';
                }
                if (image != '') {
                    this.featuredElementSecondImage.setAttribute('src', image);
                    this.featuredElementSecondImage.classList.remove('hidden');
                } else {
                    this.featuredElementSecondImage.classList.add('hidden');
                    this.featuredElementSecondImage.setAttribute('src', '');
                }
                if (url != '') {
                    this.featuredElementSecond.setAttribute('href', url);
                } else {
                    this.featuredElementSecond.setAttribute('href', '#');
                }
            }, false);
        });
    }

    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }

    getGenderCookieSettings() {
        return JSON.parse(document.querySelector('[data-gender-cookie-settings]').textContent);
    }

    swap(node1, node2) {
        const afterNode2 = node2.nextElementSibling;
        const parent = node2.parentNode;
        //if (false) {
        if (node1 === afterNode2) {
          parent.insertBefore(node1, node2);
        } else {
          node1.replaceWith(node2);
          parent.insertBefore(node1, afterNode2);
        }
    }

    checkGenderCookie() {
        if (this.genderSettings && this.genderSettings.cookieName && this.getCookie(this.genderSettings.cookieName) != '') {
            switch (this.getCookie(this.genderSettings.cookieName)) {
                // case this.genderSettings.cookieValueMen:
                //     break;
                case this.genderSettings.cookieValueWomen:
                    if (!document.querySelector('.navigation-sub li').querySelector('a[title="Woman"]')) {
                        this.swap(document.querySelector('.navigation-sub a[title="Women"]').parentElement, document.querySelector('.navigation-sub a[title="Men"]').parentElement);
                    }
                    break;
                default:
                    break;
            }
        }
    }

    handleClick(event) {
        if (event.target.closest('.nav-burger')) {
          if(!document.body.classList.contains('main-navigation--show')) {
            this.open();
            this.unsetActiveTitleLinks();
            document.querySelector('.navigation-root--title').setAttribute('active', '');
          } else {
            this.close();
          }
        }

        if (event.target.closest('.navigation-root--title') && !event.target.closest('.navigation-sub__wrapper')) {
            if (!event.target.hasAttribute('active')) {
                this.unsetActiveTitleLinks();
                event.target.setAttribute('active', '');
            }
            if (!document.body.classList.contains('main-navigation--show')) {
                this.open();
            }
        }

        if (event.target.closest('.navigation-sub')) {
          if (event.target.closest('li').classList.contains('selected')) return;

          if (event.target.closest('[data-has-children]')) {
            event.preventDefault();
            this.unselectAll();
            event.target.closest('li').classList.add("selected");
            document.querySelector('.main-navigation').classList.add('main-navigation--submenu-open');
          }
        }
        if (event.target.closest('.close-icon')) {
            this.close();
        }
        if (event.target.closest('[data-go-back]')) {
            this.unselectAll();
        }
        if (event.target.closest('.navigation-collapsible')) {
            this.toggleNavSubCollapsible();
        }

    }

    unsetActiveTitleLinks() {
        if (document.querySelector('.navigation-root--title[active]')) {
            document.querySelector('.navigation-root--title[active]').removeAttribute('active');
        }
        this.unselectAll();
    }

    unselectAll() {
        this.querySelectorAll('li').forEach(item => item.classList.remove('selected'));
        document.querySelector('.main-navigation').classList.remove('main-navigation--submenu-open');
    }

    open() {
        document.disablePageScroll();
        document.body.classList.add('main-navigation--show');
        // this.classList.add('open');
    }

    close() {
        document.enablePageScroll();
        this.querySelectorAll('li').forEach(item => item.classList.remove('selected'));
        document.body.classList.remove('main-navigation--show');
        // this.classList.remove('open');
        this.unsetActiveTitleLinks();
    }

    toggleNavSubCollapsible(){
      if(document.body.clientWidth > 750) return;
      event.preventDefault();
      if(event.target.classList.contains('open')){
        event.target.classList.remove('open')
      } else {
        event.target.classList.add('open')
      }
    }

}

customElements.define('main-navigation', MainNavigation);